import { CompanyService } from './../../service/company.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Internship } from '../../models/internship';
import { QuestionnaireService } from '../../service/questionnaire.service';
import { QuestionnaireStatusDto } from '../../models/questionnaireStatus.model';
import { Router } from '@angular/router';
import { ConfirmationnDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatIcon } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-info-questionnaire-dialog',
  standalone: true,
  templateUrl: './info-questionnaire-dialog.component.html',
  styleUrl: './info-questionnaire-dialog.component.css',
  imports: [MatIcon,CommonModule,ReactiveFormsModule, MatTooltipModule, TranslateModule]
})
export class InfoQuestionnaireDialogComponent implements OnInit{

  status?: QuestionnaireStatusDto;
  emails: { reminderMailSentAt: string; sentBy: string }[] = [];

  constructor(
    private dialogRef: MatDialogRef<InfoQuestionnaireDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public internshipData: Internship, private route: Router,
    private dialog: MatDialog, private questionnaireService: QuestionnaireService,
    private companyService: CompanyService, private translate: TranslateService ) {
    console.log('Dati ricevuti nel dialog:', this.internshipData);
    }

    ngOnInit(): void {
      if(this.internshipData.traineeId){
        console.log(this.internshipData.traineeId)
        this.questionnaireService.getStatusByUser(this.internshipData.traineeId).subscribe({
              next: (res) => {
                console.log('Stato questionario ricevuto:', res);
                this.status = res;
              },
              error: (err) => {
                console.error('Errore nel recupero dello stato questionario', err);
              }
            });
      };

      if(this.internshipData.id){
        console.log("this.internshipData.id ",this.internshipData.id)
          this.companyService.getInternshipEmails(this.internshipData.id).subscribe({
            next: (res: any) => { this.emails = res; console.log(this.emails)},
            error: (err: any) => console.error('Errore recupero cronologia mail', err)
          });
      }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  /*sendQuestionnaireMail() {
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
      width: '400px',
      data: { message: this.translate.instant('questionnaire-dialog.confirm-send-email') }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.internshipData.id) {
          console.error('ID del tirocinio mancante');
          return;
        }

        const newEmail = {
          sentBy: 'manual',
          reminderMailSentAt: new Date().toISOString() 
        };
        this.emails.push(newEmail);

        this.companyService.sendReminderManually(this.internshipData.id).subscribe({
          next: (res: any) => {
            console.log('Tirocinante aggiornato con successo:', res);
            // Aggiorna stato locale per mostrare subito che la mail è stata inviata
            this.internshipData.reminderMailSent = true;
            this.internshipData.reminderMailSentAt = new Date(); 
          },
          error: (err: any) => {
            console.error('Errore durante aggiornamento:', err);
            alert(this.translate.instant('questionnaire-dialog.errors.update'));
          }
        });
      }
    });
  }*/

    sendQuestionnaireMail() {
  const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
    width: '400px',
    data: { message: this.translate.instant('questionnaire-dialog.confirm-send-email') }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (!result) return;

    if (!this.internshipData.id) {
      console.error('ID del tirocinio mancante');
      return;
    }

    this.companyService.sendReminderManually(this.internshipData.id).subscribe({
      next: (res: any) => {
        console.log('Mail inviata con successo:', res);

        const newEmail = {
          sentBy: 'manuale',
          reminderMailSent: true,
          reminderMailSentAt: new Date().toISOString()
        };

        this.emails.push(newEmail);
        this.internshipData.reminderMailSent = true;
        this.internshipData.reminderMailSentAt = new Date();
      },
      error: (err: any) => {
        console.error('Errore durante invio mail:', err);
        alert(this.translate.instant('questionnaire-dialog.errors.update'));
      }
    });
  });
}

  today(): Date {
    return new Date();
  }

  viewQuestionnaire() {
    console.log(this.status?.questionnaireId)

    this.dialogRef.close();
    this.route.navigate(['/view-questionnaire', this.status?.questionnaireId], 
                        { queryParams: {returnUrl: '/internships'},
                          state: {
                            title: this.translate.instant('inclusion-index.trainee-assessment-title'),
                            subtitle: this.translate.instant('inclusion-index.trainee-assessment-subtitle'),
                            authorName: `${this.internshipData.traineeName} ${this.internshipData.traineeLastname}`,
                            dateCompilation: this.status?.dateCompilation
                          }
                        });
  }
}
